import { supabaseRestInsert } from './supabase';

export type EventType =
  | 'search'
  | 'profile_view'
  | 'banner_interest'
  | 'banner_submit'
  | 'registration'
  | 'member_merge'
  | 'member_unmerge';

interface EventData {
  [key: string]: unknown;
}

export async function logActivity(eventType: EventType, eventData: EventData = {}): Promise<void> {
  try {
    await supabaseRestInsert('activity_log', {
      event_type: eventType,
      event_data: eventData,
    });
  } catch (err) {
    // Logging nunca pode quebrar a experiência do usuário
    console.error('[ActivityLog] Failed to log event:', eventType, err);
  }
}